import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Col,
  Container,
  Row } from 'reactstrap';

class DTCDeclinedOffer extends Component {
  render() {
    return (
      <div className="page-apply">
        <Container>

          <Row className="mb-3 mt-4">
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto">
              <h3 className="ml-auto mr-auto mb-2">Unfortunately LendingUSA is unable to approve you for a loan at this time.</h3>
              <p className="mb-1">An adverse action notice will be sent within 30 days as to why we were unable to approve your application through Cross River Bank.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto mb-5">
              <h2 className="mb-3"><u>But wait!</u><br /> We have another option:</h2>
              <h4 className="mb-4 mt-1">FreshstartLending might be able to help<br /> you qualify for the loan you need</h4>
              <h4 className="mb-1 mt-1">Call now for a free consultation!</h4>
              <h1 className="mb-3"><a href="tel:8885028027" className="cta-arrows text-danger">888-502-8027</a></h1>
              <img src="/images/fsl-logo.svg" alt="Personify Financial" width="85%" className="mb-4" />
              <Link to="/dashboard" className="text-secondary d-block">No thank you, I'm not interested</Link>
            </Col>
          </Row>

        </Container>
      </div>
    )
  }
}

export default DTCDeclinedOffer;
